import { createFileRoute } from '@tanstack/react-router'
import { GerenciarRegras } from '@/features/gerenciar-regras'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/regras/')({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: GerenciarRegras,
})
